import { render, staticRenderFns } from "./privacyPolicyCN.vue?vue&type=template&id=781060e8&scoped=true"
import script from "./privacyPolicyCN.vue?vue&type=script&lang=js"
export * from "./privacyPolicyCN.vue?vue&type=script&lang=js"
import style0 from "./privacyPolicyCN.vue?vue&type=style&index=0&id=781060e8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "781060e8",
  null
  
)

export default component.exports